import React, { useEffect, useState } from 'react';

import LogoAncona from '../assets/img/LogoAncona.png';
import { crmAPI } from '../server';
import MapPicker from './MapPicker';

type FormProps = {
  onSubmit?: (data: Record<string, string>) => void;
};

const Form: React.FC<FormProps> = ({ onSubmit }) => {
  const [tipoCliente, setTipoCliente] = useState<string>('');
  const [nombreComercial, setNombreComercial] = useState<string>('');
  const [duenoEncargado, setDuenoEncargado] = useState<string>('');
  const [celular, setCelular] = useState<string>('');
  const [encargado1Nombre, setEncargado1Nombre] = useState<string>('');
  const [encargado1Celular, setEncargado1Celular] = useState<string>('');
  const [encargado2Nombre, setEncargado2Nombre] = useState<string>('');
  const [encargado2Celular, setEncargado2Celular] = useState<string>('');
  const [rfc, setRfc] = useState<string>('');
  const [razonSocial, setRazonSocial] = useState<string>('');
  const [coords, setCoords] = useState<{ lat: number; lng: number } | null>(null);
  const ubicacion = coords ? `${coords.lat.toFixed(6)}, ${coords.lng.toFixed(6)}` : '';
  const [submitted, setSubmitted] = useState<boolean>(false);
  const [submitting, setSubmitting] = useState<boolean>(false);
  const [errorToast, setErrorToast] = useState<string>('');

  useEffect(() => {
    if (!errorToast) return;
    const id = setTimeout(() => setErrorToast(''), 4000);
    return () => clearTimeout(id);
  }, [errorToast]);

  const errors = {
    tipoCliente: !tipoCliente,
    nombreComercial: !nombreComercial.trim(),
    
    duenoEncargado: !duenoEncargado.trim(),
    celular: celular.length !== 10,
    encargado1Nombre: !encargado1Nombre.trim(),
    encargado1Celular: encargado1Celular.length !== 10,
    coords: !coords,
  };

  const hasErrors = Object.values(errors).some(Boolean);

  const UpdateCustomer: React.FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault();
    setSubmitted(true);

    if (hasErrors || submitting) {
      return;
    }

    const Contactos = [
      {
        FirstName: encargado1Nombre,
        Phone: encargado1Celular,
        Mobile: encargado1Celular,
      },
    ];

    if (encargado2Nombre.trim() && encargado2Celular.length === 10) {
      Contactos.push({
        FirstName: encargado2Nombre,
        Phone: encargado2Celular,
        Mobile: encargado2Celular,
      });
    }

    const data = {
      Name: duenoEncargado,
      ComercialName: nombreComercial,
      PhoneNumber: celular,
      Segment: tipoCliente,
      U_AA_COORDENADAS: ubicacion,
      Corporation: razonSocial,
      RFC: rfc,
      Contactos,
    };

    setSubmitting(true);
    crmAPI
      .updateCliente(data)
      .then(() => {
        setSubmitting(false);
        if (onSubmit) {
          onSubmit({ nombreComercial });
        }
      })
      .catch((err) => {
        setSubmitting(false);
        const data = err?.response?.data;
        const fromErrors = Array.isArray(data?.errors)
          ? data.errors.join(', ')
          : typeof data?.errors === 'string'
            ? data.errors
            : '';
        const message =
          fromErrors ||
          data?.message ||
          (typeof data === 'string' ? data : '') ||
          err?.message ||
          'Ocurrió un error al registrar el cliente. Intenta de nuevo.';
        setErrorToast(message);
      });
  };

  const inputClasses =
    'w-full p-md border border-outline-variant rounded-lg font-body-md bg-surface focus:border-2 focus:border-primary focus:outline-none';
  const errorClasses = 'border-red-500 focus:border-red-500';
  const cls = (hasError: boolean) =>
    `${inputClasses} ${submitted && hasError ? errorClasses : ''}`;

  return (
    <div className="bg-surface text-on-surface min-h-screen pb-24">
      <header className="flex items-center w-full px-4 h-16 bg-surface border-b border-outline-variant fixed top-0 z-50 justify-center">
        <img 
          src={LogoAncona }
          alt="Ancona Pro Logo" 
          className="h-10 w-auto object-contain" 
        />
      </header>

      <main className="pt-20 px-4 max-w-2xl mx-auto">
        <div className="mb-lg relative h-28 rounded-xl overflow-hidden benefit-card-shadow">
          <div className="absolute inset-0 bg-gradient-to-r from-primary to-primary-container opacity-90 z-10" />
          <img
            alt="Workshop"
            className="absolute inset-0 w-full h-full object-cover"
            src="https://lh3.googleusercontent.com/aida-public/AB6AXuC8f6-qKe7DX01I6O6xX9hapM3iTCtqUo9mXa3P8ePafb05Atn-VgavZlKaS8AH1MufNaamOaDMu-cUukuFyx6N6AwPCFsml_cSwA1410vDe0UJlwLNRBGvoRPXCEo78SGVWnZnpJYwi4YbBG6vG-Lfkis8TpV2GiiHWf5n5X6vC_cnz99rA9PT8OxM1sDxXN_-DejZ6JBZLvaKC3umc6DTFtgZaBG_6m4IKoG8dYB5jSgEmeHgl8xKdxWz4hI3Jq9Vdc8Kmczp8g"
          />
          <div className="relative z-20 px-lg py-md flex flex-col h-full justify-center">
            <span className="text-on-secondary-container bg-secondary px-3 py-1 rounded-full text-label-bold font-label-bold inline-block mb-1 w-fit">
              MEMBRESÍA
            </span>
            <h2 className="text-on-secondary font-headline-lg text-headline-md">
              Activación ANCONA PRO
            </h2>
          </div>
        </div>

        <form className="space-y-lg" onSubmit={UpdateCustomer}>
          <div
            className={`bg-surface-container-lowest p-lg rounded-xl benefit-card-shadow border-t-4 border-secondary ${
              submitted && errors.tipoCliente ? 'ring-2 ring-red-500' : ''
            }`}
          >
            <label className="text-label-bold font-label-bold text-primary mb-md block">
              TIPO DE CLIENTE
            </label>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-md">
              {['Taller', 'Flotilla', 'Empresa'].map((option) => (
                <label
                  key={option}
                  className={`flex items-center p-md border rounded-lg cursor-pointer hover:bg-surface-variant transition-all ${
                    submitted && errors.tipoCliente ? 'border-red-500' : 'border-outline-variant'
                  }`}
                >
                  <input
                    type="radio"
                    name="tipo_cliente"
                    value={option}
                    checked={tipoCliente === option}
                    onChange={(e) => setTipoCliente(e.target.value)}
                    className="w-5 h-5 text-secondary border-outline focus:ring-secondary"
                  />
                  <span className="ml-sm font-body-md">{option}</span>
                </label>
              ))}
            </div>
          </div>

          <div className="bg-surface-container-lowest p-lg rounded-xl benefit-card-shadow">
            <div className="space-y-md">
              <div>
                <label className="text-label-bold font-label-bold text-on-surface-variant mb-xs block">
                  NOMBRE COMERCIAL
                </label>
                <input
                  type="text"
                  value={nombreComercial}
                  onChange={(e) => setNombreComercial(e.target.value)}
                  placeholder="Ej: Refaccionaria El Rayo"
                  maxLength={155}
                  className={cls(errors.nombreComercial)}
                />
              </div>
              <div>
                <label className="text-label-bold font-label-bold text-on-surface-variant mb-xs block">
                  DUEÑO / ENCARGADO
                </label>
                <input
                  type="text"
                  value={duenoEncargado}
                  onChange={(e) => setDuenoEncargado(e.target.value)}
                  placeholder="Nombre completo"
                  maxLength={155}
                  className={cls(errors.duenoEncargado)}
                />
              </div>
              <div>
                <label className="text-label-bold font-label-bold text-on-surface-variant mb-xs block">
                  CELULAR (NÚMERO DE CLIENTE)
                </label>
                <input
                  type="tel"
                  value={celular}
                  onChange={(e) => setCelular(e.target.value.replace(/\D/g, '').slice(0, 10))}
                  placeholder="10 dígitos"
                  maxLength={10}
                  className={cls(errors.celular)}
                />
              </div>
            </div>
          </div>

          <div className="bg-surface-container-lowest p-lg rounded-xl benefit-card-shadow border-l-4 border-primary">
            <div className="flex items-center gap-2 mb-md">
              <span className="material-symbols-outlined text-primary">person_check</span>
              <h3 className="text-label-bold font-label-bold text-primary">
                ENCARGADO DE COMPRAS 1
              </h3>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-md">
              <input
                type="text"
                value={encargado1Nombre}
                onChange={(e) => setEncargado1Nombre(e.target.value)}
                placeholder="Nombre"
                maxLength={155}
                className={cls(errors.encargado1Nombre)}
              />
              <input
                type="tel"
                value={encargado1Celular}
                onChange={(e) => setEncargado1Celular(e.target.value.replace(/\D/g, '').slice(0, 10))}
                placeholder="Celular"
                maxLength={10}
                className={cls(errors.encargado1Celular)}
              />
            </div>
          </div>

          <div className="bg-surface-container-lowest p-lg rounded-xl benefit-card-shadow border-l-4 border-outline">
            <div className="flex items-center gap-2 mb-md">
              <span className="material-symbols-outlined text-on-surface-variant">person_add</span>
              <h3 className="text-label-bold font-label-bold text-on-surface-variant">
                ENCARGADO DE COMPRAS 2 (OPCIONAL)
              </h3>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-md">
              <input
                type="text"
                value={encargado2Nombre}
                onChange={(e) => setEncargado2Nombre(e.target.value)}
                placeholder="Nombre"
                maxLength={155}
                className={inputClasses}
              />
              <input
                type="tel"
                value={encargado2Celular}
                onChange={(e) => setEncargado2Celular(e.target.value.replace(/\D/g, '').slice(0, 10))}
                placeholder="Celular"
                maxLength={10}
                className={inputClasses}
              />
            </div>
          </div>

          <div className="bg-surface-container-lowest p-lg rounded-xl benefit-card-shadow">
            <label className="text-label-bold font-label-bold text-on-surface-variant mb-md block">
              COMPLETA LA INFORMACIÓN SI FACTURAS
            </label>
            <div className="space-y-md">
              <input
                type="text"
                value={rfc}
                onChange={(e) => setRfc(e.target.value.toUpperCase().slice(0, 13))}
                placeholder="RFC"
                maxLength={13}
                className={`${inputClasses} uppercase`}
              />
              <input
                type="text"
                value={razonSocial}
                onChange={(e) => setRazonSocial(e.target.value)}
                placeholder="Nombre de Facturación (Razón Social)"
                maxLength={155}
                className={inputClasses}
              />
            </div>
          </div>

          <div
            className={`bg-surface-container-lowest p-lg rounded-xl benefit-card-shadow overflow-hidden ${
              submitted && errors.coords ? 'ring-2 ring-red-500' : ''
            }`}
          >
            <label className="text-label-bold font-label-bold text-on-surface-variant mb-md block">
              GEOLOCALIZACIÓN DEL TALLER
            </label>
            <p className="text-body-sm text-on-surface-variant mb-sm">
              Se detectará tu ubicación automáticamente. Puedes mover el pin o tocar el mapa para ajustarla y luego confirmar.
            </p>
            <MapPicker value={coords} onChange={setCoords} />
            <div className="mt-sm flex items-center gap-2">
              <span
                className={`material-symbols-outlined ${
                  submitted && errors.coords ? 'text-red-500' : 'text-secondary'
                }`}
                style={{ fontVariationSettings: '"FILL" 1', fontSize: 20 }}
              >
                location_on
              </span>
              <span
                className={`font-label-bold text-sm ${
                  submitted && errors.coords ? 'text-red-500' : 'text-primary'
                }`}
              >
                {ubicacion || 'Sin ubicación seleccionada'}
              </span>
            </div>
          </div>

          <div className="pt-lg pb-xl">
            {submitted && hasErrors && (
              <p className="text-center text-red-500 font-label-bold mb-md">
                Por favor completa los campos obligatorios en rojo.
              </p>
            )}
            <button
              type="submit"
              disabled={submitting}
              className="w-full bg-primary text-on-primary py-4 rounded-xl text-headline-md font-headline-md shadow-lg active:scale-95 transition-all flex justify-center items-center gap-2 hover:bg-primary-container disabled:opacity-60 disabled:cursor-not-allowed"
            >
              {submitting ? 'Enviando...' : 'Finalizar Registro'}
              <span className="material-symbols-outlined">rocket_launch</span>
            </button>
            <p className="text-center text-body-sm text-on-surface-variant mt-md">
              Al finalizar, confirmas que los datos proporcionados son correctos para el alta en el
              programa de lealtad.
            </p>
          </div>
        </form>
      </main>

      {errorToast && (
        <div
          role="alert"
          className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 bg-green-600 text-white px-4 py-3 rounded-lg shadow-lg flex items-center gap-2 max-w-md w-[90%]"
        >
          <span className="material-symbols-outlined">error</span>
          <span className="font-label-bold flex-1">{errorToast}</span>
          <button
            type="button"
            onClick={() => setErrorToast('')}
            className="material-symbols-outlined opacity-80 hover:opacity-100"
          >
            close
          </button>
        </div>
      )}
    </div>
  );
};

export default Form;
